import { allVarsObj } from './allVars';
import { blackVars } from './blackVars';
import { redVars } from './redVars';
import { greenVars } from './greenVars';
import { blueVars } from './blueVars';
import { yellowVars } from './yellowVars';
import { defaultVars1 } from './defaultVars1';
import { defaultVars } from './defaultVars';
import { getMixinVars } from './mixinVars';

function getVars(themeType, mixinColor) {
    if (themeType.startsWith('initial')) { // 适用于黑色主题内部嵌套其他主题
        const targetType = themeType.split('-')[1] || 'default';
        const initialVars = { ...blackVars };
        for (let k in initialVars) {
            initialVars[k] = 'initial';
        }
        return { ...initialVars, ...getVars(targetType, mixinColor) }
    }
    let vars = {};
    switch (themeType) {
        case 'mixin':
            vars = getMixinVars(mixinColor)
            break;
        case 'black':
            vars = blackVars;
            break;
        case 'red':
            vars = redVars;
            break;
        case 'green':
            vars = greenVars;
            break;
        case 'blue':
            vars = blueVars;
            break;
        case 'yellow':
            vars = yellowVars;
            break;
        case 'default1':
            vars = defaultVars1;
            break;
        case 'default':
            vars = defaultVars;
            break;
        default:
            break;
    }
    return vars;
}

// 设置主题
export function setVarsByThemeName(themeType, mixinColor, rootElement, customVars = {}) {
    const allVars = allVarsObj;
    // 需要考虑：
    // 这个 allVars 全不全不一定呀，万一有的变量在特殊主题下有，这个全部变量里又没加，那么这部分就赋不上值了（下方代码是通过循环全部变量来替换和移除的）
    // 但是吧，又不能合并，这里边的默认值都不对
    // 所以别的主题内加了啥变量，还得把这个变量放进 allVars ,妥妥的多写一遍
    // 这个主题搞的是一塌糊涂。。。
    // 正常逻辑: 一个公共变量（各主题都适用的），然后合并主题特殊变量，就是所需要的全部主题相关变量
    let vars = { ...getVars(themeType, mixinColor), ...customVars }; // 合并
    var root = document.querySelector(rootElement || ':root');

    // TODO 这里有个问题是，设置一个属性就有可能导致页面刷新一次，所以要想办法只设置一次，但是还要注意不要影响其他人设置的属性
    // 设置下全局变量
    for (const key in allVars) {
        if (Object.hasOwnProperty.call(vars, key)) { // 有的话替换
            const element = vars[key];
            root && root.style && root.style.setProperty && root.style.setProperty(key, element);
        } else { // 没有的话移除
            root && root.style && root.style.setProperty && root.style.removeProperty(key);
        }
    }
}